import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { useGlobalConfigContext } from '../global-config'
import { StaticImage } from '../image'
import {
  urlResolverGetEprescriptionInfo,
  urlResolverGetErxFamilyLandingPage,
  urlResolverGetRedeemPaperPrescription,
  urlResolverGetRezeptbonusLandingPage,
  urlResolverGetShopApothekeApp,
  urlResolverNfcLandingPage,
} from '../url-handling'

import { ErxHubArrowLink } from './ErxHubArrowLink'
import ImgAboutRecipe from './images/ImgAboutRecipe.png'

export const ErxHubPrescriptionCard: FC = () => {
  const globalConfig = useGlobalConfigContext()
  const intl = useIntl()

  return (
    <div className="flex flex-1 flex-col overflow-hidden rounded-m font-medium">
      <div className="h-36 w-full bg-light-brand-high">
        <StaticImage
          alt={intl.formatMessage({
            id: 'nfc.moreInfo.prescription.title',
          })}
          className="w-full"
          src={ImgAboutRecipe}
        />
      </div>
      <div className="flex w-full grow gap-4 bg-light-brand-medium p-4">
        <span className="text-m">
          <FormattedMessage id="nfc.moreInfo.prescription.title" />
        </span>

        <div className="flex w-full flex-col gap-2">
          <ErxHubArrowLink url={urlResolverGetEprescriptionInfo(globalConfig)}>
            <FormattedMessage id="nfc.moreInfo.prescription.ePrescription" />
          </ErxHubArrowLink>
          <ErxHubArrowLink url={urlResolverNfcLandingPage(globalConfig)}>
            <FormattedMessage id="nfc.moreInfo.prescription.card" />
          </ErxHubArrowLink>
          <ErxHubArrowLink
            url={urlResolverGetRedeemPaperPrescription(globalConfig)}
          >
            <FormattedMessage id="nfc.moreInfo.prescription.paperAndPrivate" />
          </ErxHubArrowLink>
          <ErxHubArrowLink
            url={urlResolverGetErxFamilyLandingPage(globalConfig)}
          >
            <FormattedMessage id="nfc.moreInfo.prescription.erxFamily" />
          </ErxHubArrowLink>
          <ErxHubArrowLink
            url={urlResolverGetRezeptbonusLandingPage(globalConfig)}
          >
            <FormattedMessage id="nfc.moreInfo.prescription.bonus" />
          </ErxHubArrowLink>
          <ErxHubArrowLink url={urlResolverGetShopApothekeApp(globalConfig)}>
            <FormattedMessage id="nfc.moreInfo.prescription.app" />
          </ErxHubArrowLink>
        </div>
      </div>
    </div>
  )
}
